import React from "react";
import { Box, Card, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { CardTitle, CardDesc } from "../../../elements/color-cta-cards/styles";
import { CLICK } from "../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../_foundation/gtm/async.service";

interface CardProps {
  closeHeaderMenu?: () => any;
  chipName: string;
  title: string;
  desc: string;
  ctaLink: string;
  btnLabel: string;
  cardTheme: "red" | "blue";
  gtmData?: Record<string, any>;
}

const cardStyles = {
  padding: "18px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const chipStyles = {
  display: "inline-block",
  backgroundColor: "rgba(255,255,255,0.2)",
  color: "#FFFFFF",
  fontSize: "8px",
  fontWeight: 700,
  borderRadius: "6px",
  padding: "4px 8px",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  mb: 0.5,
  backdropFilter: "blur(4px)",
};

const btnStyles = {
  background: "#FFF",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  textTransform: "uppercase",
  borderRadius: "8px",
  padding: "8px 12px",
  width: "100%",
  mt: 3,
  "&:hover": { background: "#FFF" },
};

export const DesktopActionCard: React.FC<CardProps> = ({
  closeHeaderMenu,
  chipName,
  title,
  desc,
  ctaLink,
  btnLabel,
  cardTheme,
  gtmData = {},
}) => {
  const navigate = useNavigate();

  const onCtaClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      ...gtmData,
      btn_label: btnLabel,
      click_destination: ctaLink,
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(ctaLink);
  };

  const bgColor = cardTheme === "blue" ? "#5D89A2" : "#C41E3B";
  const btnColor = cardTheme === "blue" ? "#3D6881" : "#C41E3B";

  return (
    <Card sx={{ ...cardStyles, backgroundColor: bgColor }}>
      <Box>
        <Box sx={chipStyles}>{chipName}</Box>
        <CardTitle style={{ color: "#FFFFFF", fontSize: "20px", lineHeight: "24px", marginBottom: "8px" }}>
          {title}
        </CardTitle>
        <CardDesc style={{ color: "#FFFFFF", fontSize: "13px", lineHeight: "19px", fontWeight: 600 }}>{desc}</CardDesc>
      </Box>
      <Button variant="contained" onClick={onCtaClick} sx={{ ...btnStyles, color: btnColor }}>
        {btnLabel}
      </Button>
    </Card>
  );
};
